export enum TabType {
    ACTIVE_SESSION,
    CHAT_HISTORY,
    USER_MANAGEMENT
}